import { useEffect, useRef, useState, useCallback } from "react";
import { motion } from "framer-motion";

export function MouseFollowRefraction() {
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const rafRef = useRef<number>(0);

  const handler = useCallback((e: MouseEvent) => {
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      setPos({ x: Math.max(0, Math.min(100, x)), y: Math.max(0, Math.min(100, y)) });
    });
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", handler, { passive: true });
    return () => {
      window.removeEventListener("mousemove", handler);
      cancelAnimationFrame(rafRef.current);
    };
  }, [handler]);

  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-0">
      {/* Primary indigo orb */}
      <motion.div
        className="absolute will-change-transform rounded-full"
        initial={false}
        animate={{
          x: `calc(${pos.x}vw - 350px)`,
          y: `calc(${pos.y}vh - 350px)`,
        }}
        transition={{ type: "spring", stiffness: 25, damping: 18, mass: 1.2 }}
        style={{
          width: 700,
          height: 700,
          top: 0,
          left: 0,
          background:
            "radial-gradient(circle, hsl(243 75% 59% / 0.2) 0%, hsl(243 75% 59% / 0.08) 30%, hsl(178 70% 50% / 0.04) 60%, transparent 80%)",
          filter: "blur(80px)",
          opacity: 0.6,
          contain: "layout style paint",
        }}
      />
      {/* Secondary teal orb (inverse follow) */}
      <motion.div
        className="absolute will-change-transform rounded-full"
        initial={false}
        animate={{
          x: `calc(${100 - pos.x}vw - 250px)`,
          y: `calc(${100 - pos.y}vh - 250px)`,
        }}
        transition={{ type: "spring", stiffness: 18, damping: 22, mass: 1.5 }}
        style={{
          width: 500,
          height: 500,
          top: 0,
          left: 0,
          background:
            "radial-gradient(circle, hsl(178 70% 50% / 0.15) 0%, hsl(262 83% 58% / 0.06) 50%, transparent 80%)",
          filter: "blur(100px)",
          opacity: 0.5,
          contain: "layout style paint",
        }}
      />
      {/* Small highlight orb near cursor */}
      <motion.div
        className="absolute will-change-transform rounded-full"
        initial={false}
        animate={{
          x: `calc(${pos.x}vw - 100px)`,
          y: `calc(${pos.y}vh - 100px)`,
        }}
        transition={{ type: "spring", stiffness: 60, damping: 15, mass: 0.5 }}
        style={{
          width: 200,
          height: 200,
          top: 0,
          left: 0,
          background:
            "radial-gradient(circle, hsl(210 40% 96% / 0.06) 0%, transparent 70%)",
          filter: "blur(40px)",
          opacity: 0.8,
          contain: "layout style paint",
        }}
      />
    </div>
  );
}
